// extracted by mini-css-extract-plugin
export default {"checkbox":"Checkbox_checkbox__I+UWc","invalid":"Checkbox_invalid__zms24"};